import store from 'base/reducer/store';
import { FetchingProjectItemsActionType, PersistProjectItemsActionType } from 'features/Persist/actionTypes';
import { getTenantId } from 'features/Tenant/tenantUtils';
import { TenantIsActiveDeltaRequest , ProjectRoleClient, ProjectIsActiveResponse } from 'services/tenantManagementService';
import { tryCatchJsonByAction } from 'utils/fetchUtils';

export const getProjectRolesAction = (projectId: number) => {
	const tenantId = getTenantId()!;
	const client = new ProjectRoleClient();
	return client.getAllByProjectId(tenantId, projectId);
}

export const updateProjectRolesAction = (projectId: number, model: TenantIsActiveDeltaRequest ) => {
	const tenantId = getTenantId()!;
	const client = new ProjectRoleClient();
	return client.update(tenantId, projectId, model);
}

export const persistProjectRolesAction = async (projectId: number) => {
	const state = store.getState();

	if (state.persistedProjectRole.projectMap[projectId]?.fetching) {
		return;
	}

	store.dispatch(setProjectRolesFetchingAction(true, projectId));

	const bindedAction = getProjectRolesAction.bind(null, projectId);
	const response = await tryCatchJsonByAction(bindedAction);

	if (response.success && response.items) {
		store.dispatch(setProjectRolesAction(projectId, response.items || []));
	} else {
		store.dispatch(setProjectRolesFetchingAction(false, projectId));
	}
}

// persist project roles redux

export const PROJECT_ROLES_FETCHING = 'PROJECT_ROLES_FETCHING';
export const PROJECT_ROLES_SET = 'PROJECT_ROLES_SET';

const setProjectRolesFetchingAction = (fetching: boolean, projectId: number): FetchingProjectItemsActionType => {
	return {
		type: PROJECT_ROLES_FETCHING,
		fetching,
		projectId
	}
}

const setProjectRolesAction = (projectId: number, items: ProjectIsActiveResponse[]): PersistProjectItemsActionType<ProjectIsActiveResponse> => {
	return {
		type: PROJECT_ROLES_SET,
		items,
		projectId
	}
}
